// src/components/modal/produtos/SelecaoVariacoes.js
import Select from '../../input/Select';
import { formatCurrency } from '../../../utils/numberUtils';
import { obterGruposVariacao, selecionarItemVariacao } from '../../../utils/VariacaoUtils';
export default function SelecaoVariacoes({ produto, escolhas = [], erros = {}, onChange }) {
  return obterGruposVariacao(produto).map(grupo => <Select key={grupo.variacaoId}
    label={grupo.variacao?.descricao || 'Variação'} size={240}
    value={escolhas.find(v => Number(v.variacaoId) === Number(grupo.variacaoId))?.variacaoItemId || ''}
    options={[{value:'', label:'Selecione', disabled:true}, ...(grupo.variacao?.variacaoItens || []).map(item => ({ value:item.id,
      label:item.descricao + (Number(item.valorAdicional)>0 ? ' (+' + formatCurrency(item.valorAdicional) + ')' : '') }))]}
    msgErro={erros[grupo.variacaoId]} onChange={e => onChange(selecionarItemVariacao(produto, escolhas, grupo.variacaoId, e.target.value))} />);
}
